<template>
  <v-switch
    v-model="tradeEngineEnabled"
    :label="tradeEngineEnabled ? `Enabled` : `Disabled`"
    :disabled="api_form.api_key === '' && api_form.api_secret === ''"
  ></v-switch>
</template>

<script>
import swal from "sweetalert2";
import axios from "axios";
import {mapGetters} from "vuex";

export default {
  props: ["exchange"],
  data() {
    return {
      api_form: {
        api_key: "",
        api_secret: ""
      },
      trade_engine_on: false
    };
  },
  computed: {
    ...mapGetters({
      themeDark: "settings/darkmode"
    }),
    tradeEngineEnabled: {
      get: function() {
        return this.trade_engine_on;
      },
      set: async function(value) {
        try {
          await axios.put("/api/v1/settings/toggle-trade-engine-status", {
            exchange: this.exchange,
            status: value
          });

          this.trade_engine_on = value;
        } catch (error) {
          swal({
            title: "API keys error",
            text: error.response.data,
            showConfirmButton: false,
            showCloseButton: true,
            customClass: this.themeDark ? "swal-type-error-dark" : "swal-type-error",
            imageUrl: "/img/popup_img_error.png",
            imageHeight: 80,
            imageWidth: 80
          });

          this.trade_engine_on = !value;
          return false;
        }
      }
    }
  },
  mounted: async function() {
    axios.get("/api/v1/settings/api-key/" + this.exchange).then(res => {
      if (res.data.pivot) {
        // We have some settings found for this exchange
        this.api_form.api_key = res.data.pivot.api_key;
      }
    });
    axios
      .get("/api/v1/settings/trade-engine-status/" + this.exchange)
      .then(res => {
        this.trade_engine_on = res.data.trade_engine_on;
      });
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/settings/TradeEngineSwitch.vue